/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
	"INID.survey.moreThanNeeded" : "Többször használtam mint a felírt mennyiség",
	"INID.survey.asNeeded" : "A felírt mennyiségben",
	"INID.survey.notUsed" : "Nem használtam",
	"INID.survey.feltSick" : "Nagyon rosszul voltam",
	"INID.survey.hardlyBearable" : "Nehezen volt elviselhető",
	"INID.survey.smallProblem" : "Csak kisebb problémám volt",
	"INID.survey.hadNoProblem" : "Mégsem volt tünetem",
	"INID.survey.causePhysical" : "Fizikai terhelés, futás, nevetés, sírás",
	"INID.survey.causeSmog" : "Szmog",
	"INID.survey.causeWind" : "Szél",
	"INID.survey.causeEmotion" : "Érzelmek",
	"INID.survey.causeUnknown" : "Nem tudom",
	"INID.unit.lpm" : "Liter / perc",
	"INID.unit.mlpm" : "Milliliter / perc",
	"INID.unit.cm" : "cm",
	"INID.unit.kg" : "kg",
	"INID.survey.asthma" : "Asztma",
	"INID.survey.copd" : "COPD",
	"INID.survey.allergy" : "Allergia",

	"INID.survey.lastHour": "Az elmúlt órában",
	"INID.survey.forenoon": "Délelőtt",
	"INID.survey.night": "Éjszaka",
	"INID.survey.yesterDayEvening": "Tegnap este",
	"INID.survey.other": "Más időpontban",

	"INID.survey.controlWorkoutNone": "Nem volt rá alkalmam",
	"INID.survey.controlWorkoutWeeklyTwo": "Heti 2 órát",
	"INID.survey.controlWorkoutWeeklyFour": "Heti 4 órát",
	"INID.survey.controlWorkoutWeeklySix": "Heti 6 órát",
	"INID.survey.controlWorkoutWeeklyMore": "Több mint 8 órát hetente",

	"INID.survey.generalControlAll": "A felírt mennyiségben használtam",
	"INID.survey.generalControlMostly": "Többnyire a megbeszéltek szerint",
	"INID.survey.generalControlHalf": "Az adagok felét használtam",
	"INID.survey.generalControlRare": "Ritkán használtam",
	"INID.survey.generalControlNone": "Egyáltalán nem használtam",

	"INID.ACTWork.0" : "Folyamatosan",
	"INID.ACTWork.1" : "Gyakran",
	"INID.ACTWork.2" : "Néha",
	"INID.ACTWork.3" : "Ritkán",
	"INID.ACTWork.4" : "Soha",

	"INID.ACTBreath.0" : "Naponta többször",
	"INID.ACTBreath.1" : "Naponta egyszer",
	"INID.ACTBreath.2" : "Heti 3-6 alkalommal",
	"INID.ACTBreath.3" : "Heti 1-2 alkalommal",
	"INID.ACTBreath.4" : "Egyszer sem",

	"INID.ACTSleep.0": "Hetente legalább 4 alkalommal",
	"INID.ACTSleep.1": "Hetente 2-3 éjszaka",
	"INID.ACTSleep.2": "Hetente 1 alkalommal",
	"INID.ACTSleep.3": "Heti 1-2 alkalommal",
	"INID.ACTSleep.4": "Soha",

	"INID.ACTMedication.0": "Naponta legalább 3 alkalommal",
	"INID.ACTMedication.1": "Napi 1-2 alkalommal",
	"INID.ACTMedication.2": "Heti 2-3 alkalommal",
	"INID.ACTMedication.3": "Heti 1 alkalommal vagy ritkábban",
	"INID.ACTMedication.4": "Nem kellett használnom",

	"INID.ACTSubjective.0": "Egyáltalán nem kontrollált",
	"INID.ACTSubjective.1": "Rosszul kontrollált",
	"INID.ACTSubjective.2": "Részben kontrollált",
	"INID.ACTSubjective.3": "Jól kontrollált",
	"INID.ACTSubjective.4": "Tökéletesen kontrollált",

	"INID.ACTSummary.problem": "Nem jól kontrollált",
	"INID.ACTSummary.ok": "Jól kontrollált"
}



// WEBPACK FOOTER //
// ./src/strings/generated_hu.js